import type { FindProductsInput } from '@travel-planner/shared/schemas';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

type UseProductsDataOptions = {
  enabled?: boolean;
};

// Server-truth list query for products. Mirrors the contacts list pattern —
// `keepPreviousData` keeps the previous page on screen during pagination so
// the table doesn't blink. Filters/pagination live in URL search params at
// the call site; this hook just forwards them. `enabled` lets callers gate
// the query (e.g. the planner picker disables `list` while it switches to
// `findSimilar`). When `enabled` is false, TanStack Query ignores the
// `placeholderData` and the hook returns an empty state — no stale-list
// bleed into similar-products mode.
export const useProductsData = (
  input: FindProductsInput,
  options: UseProductsDataOptions = {}
) =>
  trpc.products.list.useQuery(input, {
    placeholderData: keepPreviousData,
    enabled: options.enabled,
  });
